import React, { FC } from 'react';
import { Button, ButtonStyles, Popup, PopupStyles } from '@silverfort/sf-components';
import { PolicyTemplate } from '../../../../types/policies';

interface Props {
    open: boolean;
    onClose: () => void;
    template?: PolicyTemplate;
    onDeleteClick: (templateId: PolicyTemplate['id']) => void;
}

interface ContentProps {
    name: string;
}

interface FooterProps {
    onCancelClick: () => void;
    onDeleteClick: () => void;
}

const Content: FC<ContentProps> = ({ name }) => {
    return (
        <span className="font-sf text-13 leading-[19px] tracking-[0.0156rem] h-[38px]">
            Are you sure you want to delete <span className="font-medium">{name}</span> template?
        </span>
    );
};

const Footer: FC<FooterProps> = ({ onCancelClick, onDeleteClick }) => (
    <div className="gap-2 flex justify-end items-center">
        <Button buttonStyle={ButtonStyles.GhostSolid} text="Cancel" onClick={onCancelClick} />
        <Button buttonStyle={ButtonStyles.DangerSolid} text="Delete" onClick={onDeleteClick} />
    </div>
);

const DeleteTemplateModal: FC<Props> = ({ open, template, onClose, onDeleteClick }) => {
    const handleDeleteClick = () => {
        if (template) {
            onDeleteClick(template.id);
        }
    };

    return (
        <Popup
            open={open}
            style={PopupStyles.Confirmation}
            title="Duplicate template"
            popupClassName="w-[360px] h-50"
            onClose={onClose}
            ContentComponent={Content}
            FooterComponent={Footer}
            ContentComponentProps={{ name: template?.name ?? '' }}
            FooterComponentProps={{ onDeleteClick: handleDeleteClick, onCancelClick: onClose }}
        />
    );
};

export default DeleteTemplateModal;
